import {
  type Dependencies,
  DependenciesProvider,
} from './contexts/dependencies.context';
import { PCSOverviewPage } from './pages/pcs-overview';

export type PCSProps = {
  dependencies: Dependencies;
};

export function PCSPage({ dependencies }: PCSProps) {
  return (
    <DependenciesProvider dependencies={dependencies}>
      <PCSOverviewPage />
    </DependenciesProvider>
  );
}
